import { requester, storeRequester } from "App";
import CustomButton from "components/buttons/CustomButton";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { QRCodeSVG } from "qrcode.react";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import style from "./QRProduct.module.scss";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import Dummy from "components/Dummy";
import HighlightedText from "components/inputs/HighlightedText";
import { AuthContext } from "providers/AuthProvider";
import { useTranslation } from "react-i18next";
import { RegionContext } from "providers/RegionProvider";
import { getCookie } from "shared/StoreRequester";
import { addCommas, decode, renderPriceInline } from "shared/utils/Utils";
import Inline from "layouts/container/Inline";
import InputNumber from "components/inputs/InputNumber";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faCancel, fas, faShoppingCart, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import cartIcon from "resources/img/cartIcon.svg";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import QuillViewer from "components/inputs/richEditor/QuillViewer";


function QRProduct() {
    const { isMobile } = useContext(BrowserDetectContext);
    const [isMounted, setMounted] = useState(false);
    const [paymentResult, setPaymentResult] = useState();
    const [isButtonDisabled, setButtonDisabled] = useState(false); // 추가된 상태 변수
    const { userName } = useContext(AuthContext);
    const [product, setProduct] = useState();
    const [slideProduct, setSlideProduct] = useState();
    const [mainImage, setMainImage] = useState("");
    const { t } = useTranslation();
    const inputs = useRef({});
    const [items, setItems] = useState([]);
    const [isIncrease, setIsIncrease] = useState(false);
    // const [quantity, setQuantity] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0); // 총 금액 상태
    const [selectedRows, setSelectedRows] = useState([]); // 선택된 row 상태
    const { regionId } = useContext(RegionContext);
    const [cartItems, setCartItems] = useState([]);

    const [interests, setInterests] = useState([]);

    const testOrderData = {
        "orderProducts": [
            {
                "id": "a5b06212-89d5-4065-b8d5-a9c8fed9183c",
                "vendorId": null,
                "categoryId": "6873ea91-b0ac-4fad-afee-fa3f13f41849",
                "brandId": null,
                "storeId": null,
                "productId": "prod_01JKFG17NCEWQT62Q9FQ0ZGN4E",
                "machineId": null,
                "machineType": null,
                "vendorName": null,
                "productName": "[위드기프트] 럭셔리 금장버튼 하이넥원피스",
                "locationNo": 0,
                "price": 5400,
                "supplyPrice": 5400,
                "productImg": "",
                "vendingId": null,
                "quantity": 1,
                "radarImg": "",
                "bannerTextImg": "",
                "liquidImg": "",
                "productDetailImg": "<p><img src=\"https://muin.shop/api/uploads/1738908147276-1d071a9f-21fb-4428-a052-5e21367be230.png\"/></p>",
                "productBgImg": ""
            }
        ],
        "amount": 5400,
        "userName": "",
        "storeCode": 5,
        "machineData": "W1swLDFdXQ==",
        "returnUrl": "https://puffuandroid.com/ws/5/mobile/main"
    }

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            storeRequester.getProduct(
                "prod_01JKFJHV49T6YDG5QXRV0YTAVF",
                {
                    expand: "images",
                    // with_price: true,
                    type: "main",
                },
                // ({ product }) => setProduct(product)
                ({ product }) => {
                    console.log(product);
                    setProduct(product);
                    setMainImage(product.thumbnail);
                }
            );
            OnClick();
        }
    }, [isMounted]);

    const PaymentQR = () => {

        const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";
        const paymentHistoryId = paymentResult && paymentResult.paymentHistoryId;



        return (
            <QRCodeSVG
                value={`http://puffuandroid.com/ws/5/paymentHistory?id=${paymentHistoryId}`}
                size={"15vw"}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={false}
            />
        );
    };


    const OnClick = () => {
        // 버튼을 비활성화
        setButtonDisabled(true);
        console.log(testOrderData);
        requester.testPaymentRequest(testOrderData, (result) => {
            if (result.code === 0) {
                let ready = result.data;
                requester.testPayment(ready, (result) => {
                    if (result.code === 0) {
                        setPaymentResult(result.data);
                        const jsonString = JSON.stringify(result.data);
                        if (window.BRIDGE && window.BRIDGE.sendPaymentResult) {
                            window.BRIDGE.sendPaymentResult(jsonString);
                        }
                    }
                    // 5초 후에 버튼을 다시 활성화
                    setTimeout(() => setButtonDisabled(false), 5000);
                });
            } else {
                toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER,
                });
                // 에러 발생 시에도 버튼을 다시 활성화
                setButtonDisabled(false);
            }
        });
    };

    // 총 금액 계산 함수
    useEffect(() => {
        const total = items.reduce((sum, item) => {
            const variant = product?.variants.find(
                (variant) => variant.id === item.variantId
            );
            const price = variant?.discount_price || variant?.price || 0;
            return sum + price * item.quantity;
        }, 0);
        setTotalPrice(total);
    }, [items, product]);




    const fetchInterests = () => {
        if (!userName) return;
        storeRequester.getInterest(
            (response) => setInterests(response.interests)
        );
    };

    const displayPrice = product ? renderPriceInline(product, userName) : '';


    useEffect(() => {
        if (userName) {
            fetchInterests();
        } else {
            setInterests([]);
        }
    }, [userName]);
    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={30}>
                    <FlexChild>
                        <div className={style.wrap}>
                            {product && (
                                <Container backgroundColor={"white"} minWidth={1200} maxWidth={1200}>
                                    <VerticalFlex gap={80}>
                                        <FlexChild >
                                            <Container minWidth={1200} maxWidth={1200} borderBottom={'3px solid #ddd'}>
                                                <HorizontalFlex gap={40} flexStart>
                                                    <FlexChild width={"max-content"} >
                                                        <VerticalFlex gap={40}>
                                                            <FlexChild>
                                                                <img
                                                                    src={mainImage}
                                                                    alt="Main Product"
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "380px",
                                                                        minWidth: "380px",
                                                                        borderRadius: "10px",
                                                                    }}
                                                                />
                                                            </FlexChild>
                                                        </VerticalFlex>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <VerticalFlex gap={17}>
                                                            <FlexChild >
                                                                <VerticalFlex gap={5}>
                                                                    <FlexChild>
                                                                        <VerticalFlex gap={10}>
                                                                            <FlexChild>
                                                                                <Center width={"100%"} textAlign={"left"}>
                                                                                    <P size={18} color={"rgba(196,196,196,1)"} weight={600}>
                                                                                        {product.categories &&
                                                                                            product.categories.length > 0 &&
                                                                                            product.categories?.[0].name}
                                                                                    </P>
                                                                                    <Dummy height={"15px"} />
                                                                                    <P size={24} color={"#444"} weight={700}>
                                                                                        {product.title}
                                                                                    </P>

                                                                                </Center>
                                                                            </FlexChild>

                                                                            <FlexChild>
                                                                                <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                                                                                    <FlexChild justifyContent={"flex-start"}>
                                                                                        <P
                                                                                            width={isMobile ? "150px" : "100%"}
                                                                                            textAlign={"left"}
                                                                                            size={isMobile ? 16 : 28}
                                                                                            weight={"bold"}
                                                                                            color={"black"}
                                                                                            textDecoration={product.currentPrice && "line-through"}
                                                                                        >
                                                                                            <HighlightedText
                                                                                                text={displayPrice}
                                                                                                highlights={['30ml', '60ml']}
                                                                                                highlightColor="#888"
                                                                                            />
                                                                                        </P>
                                                                                    </FlexChild>
                                                                                </HorizontalFlex>
                                                                            </FlexChild>
                                                                        </VerticalFlex>

                                                                    </FlexChild>
                                                                </VerticalFlex>
                                                            </FlexChild>
                                                        </VerticalFlex>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={"center"} width={"30%"}>
                                                        <Center>
                                                            <PaymentQR />
                                                            <Dummy height={"25px"} />
                                                            <CustomButton
                                                                text={"REFRESH"}
                                                                onClick={() => OnClick()}
                                                                disabled={isButtonDisabled} // 버튼 비활성화 속성 추가
                                                            />
                                                        </Center>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                                <Dummy height={50} />
                                            </Container>
                                        </FlexChild>
                                        <FlexChild>
                                            <PaddingWrapper padding={"0px 10px"}>
                                                <Container maxWidth={900}>
                                                    {// to-do remove
                                                        product?.content ? (
                                                            <QuillViewer
                                                                value={
                                                                    product.content?.startsWith("PHA")
                                                                        ? decode(product.content)
                                                                        : product.content
                                                                }
                                                            />
                                                        ) : (
                                                            <img
                                                                src={product.images?.[0]?.url}
                                                                style={{ width: "100%" }}
                                                                alt="empty"
                                                            />
                                                        )}
                                                </Container>
                                            </PaddingWrapper>
                                        </FlexChild>
                                    </VerticalFlex >
                                </Container >
                            )
                            }
                        </div >
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default QRProduct;
